import { FieldType } from './AttributeColsMod'
import { tsStudyAttribute } from '../../../Typescript/StuartPy/StudyAttribute'

function preparePatchFields(fields: FieldType[], modalData: any) {
  const patchData = modalData
  //remove readonly field
  fields
    .filter((field) => field.readonly)
    .forEach((field) => {
      delete patchData[field.field]
    })

  //remove Datagrid additions
  delete patchData['id']
  delete patchData['actions']

  //remove null values
  return Object.entries(patchData).reduce(
    (a: any, [key, val]) => (val ? ((a[key] = val), a) : a),
    {},
  ) as tsStudyAttribute
}

export default preparePatchFields
